<template>
    <div class="banner-container container-space-y">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-lg-6 col-md-12 col-xs-12">
                    <img class="img-responsive alt-adjust my-5"
                        src="https://nxmcdn.com/images/NXM/vo-assets/nxm-logo-new.png" alt="NaXum Logo">
                    <h1 class="my-5 w-75 w-md-100 banner-heading">REGISTER FOR THE LIVE STREAM</h1>
                    <p class="banner-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                        incididunt ut labore
                        et dolore
                        magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex
                        ea commodo
                        consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                        nulla
                        pariatur.</p>
                    <button type="button" data-bs-toggle="modal" data-bs-target="#register-modal"
                        class="btn btn-block btn-primary w-50 b-w-md-100 mx-auto my-5">REGISTER NOW</button>
                </div>
                <div class="col-lg-6 col-md-12 col-xs-12"></div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="register-modal" tabindex="-1" aria-labelledby="register-modal-label" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content col-md-9">
                    <div class="modal-body text-dark ">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="mt-3">
                            <h2 class="r-modal-title">WATCH PARTNERSHIP WEBINAR</h2>
                            <p class="r-modal-desc">Learn how you can become a NaXum influencer today</p>
                        </div>


                        <form @submit.prevent="submitForm" id="signupform" class="signupform">
                            <!-- HONEYPOT FIELDS START -->

                            <div class="form-group">
                                <input type="hidden" id="firstname" name="firstname" class="form-control" placeholder=""
                                    maxlength="50" v-model="honeyPot.firstname" autocomplete="off">
                            </div>
                            <div class="form-group">
                                <input type="hidden" id="lastname" name="lastname" class="form-control" placeholder=""
                                    maxlength="50" v-model="honeyPot.lastname" autocomplete="off">
                            </div>

                            <!--  HONEYPOT FIELDS END -->
                            <div class="form-group">
                                <input type="text" class="form-control " id="fname" name="fname" placeholder="First Name"
                                    maxlength="30" v-model="fName" :class="{ 'is-invalid': errors.fName }" />
                                <span v-if="errors.fName" class="error">{{ errors.fName }}</span>
                            </div>

                            <div class="form-group">
                                <input type="text" class="form-control " id="lname" name="lname" placeholder="Last Name"
                                    maxlength="30" v-model="lName" :class="{ 'is-invalid': errors.lName }" />
                                <span v-if="errors.lName" class="error">{{ errors.lName }}</span>
                            </div>
                            <div class="form-group">
                                <input type="number" class="form-control " placeholder="Best Phone Number" name="cellphone"
                                    id="cellphone" v-model="cellphone" :class="{ 'is-invalid': errors.cellphone }" />
                                <span v-if="errors.cellphone" class="error">{{ errors.cellphone }}</span>
                            </div>

                            <div class="form-group">
                                <input
                                    type="email"
                                    class="form-control"
                                    placeholder="Email"
                                    name="email"
                                    id="email"
                                    maxlength="50"
                                    v-model="email"
                                    @blur="emailAvailable"
                                    ref="email"
                                    :class="{ 'is-invalid': errors.email }"
                                    />
                                <span v-if="errors.email" class="error">{{ errors.email }}</span>
                            </div>

                            <div class="form-group">
                                <div class="recaptcha-container" id="recaptchaContainer" ref="recaptchaContainer"></div>
                                <div>
                                    <span v-if="recaptchaError" class="error">{{ recaptchaError }}</span>
                                </div>
                            </div>


                            <button type="submit" class="btn btn-block btn-primary mx-auto my-3" id="registernow"
                                @click="submitForm">REGISTER</button>
                        </form>
                    </div>

                </div>
            </div>
        </div>
        <!-- End Modal -->
    </div>
</template>

<script>
/* global grecaptcha */
import axios from 'axios';

export default {
    name: 'LandingPage',
    data() {
        return {
            fName: '',
            lName: '',
            email: '',
            cellphone: '',
            errors: {
                fName: '',
                lName: '',
                email: '',
                cellphone: '',
            },
            showModal: false,
            honeyPot: {
                firstname: '',
                lastname: '',
            },
            recaptchaToken: '',
            recaptchaError: '',
        };
    },
    mounted() {
        this.loadRecaptchaScript();
    },
    methods: {
        // Form validation methods
        validateForm() {
            let isValid = true;

            // Clear previous errors
            this.errors.fName = '';
            this.errors.lName = '';
            this.errors.email = '';
            this.errors.cellphone = '';

            // Honeypot field validation
            if (this.honeyPot.firstname || this.honeyPot.lastname) {
                // Honeypot field has a value, indicating it's being filled by a bot
                console.log('Honeypot validation failed');
                isValid = false;
                return isValid;
            }

            // Name validation
            if (!this.fName) {
                this.errors.fName = 'First Name is required.';
                isValid = false;
            }
            if (!this.lName) {
                this.errors.lName = 'Last Name is required.';
                isValid = false;
            }

            // Email validation
            if (!this.email) {
                this.errors.email = 'Email is required.';
                isValid = false;
            } else if (!this.isValidEmail(this.email)) {
                this.errors.email = 'Invalid email format.';
                isValid = false;
            }

            // Cellphone validation
            if (!this.cellphone) {
                this.errors.cellphone = 'Phone Number is required.';
                isValid = false;
            } else if (!this.isValidCellphone(this.cellphone)) {
                this.errors.cellphone = 'Invalid Phone Number format.';
                isValid = false;
            }

            return isValid;
        },
        
        //----BEGIN EMAIL AVAILABLE
        async emailAvailable() {
            try {
                const apiUrl = process.env.VUE_APP_API_URL + "/api/enrollment/validate_email";
                const res = await axios.post(apiUrl, { email: this.email });

                const data = res.data;

                if (data.errors) {
                this.errors.email = data.errors;
                this.$refs.email?.focus();
                } else {
                delete this.errors.email;
                }

            } catch (e) {
                console.error('Email check failed:', e);
                if (e.response?.data?.errors) {
                this.errors.email = e.response.data.errors;
                } else {
                this.errors.email = "An error occurred while checking the email.";
                }
            }
        },

        //----END EMAIL AVAILABLE
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        isValidCellphone(cellphone) {
            const cellphoneRegex = /^\d{7,20}$/;
            return cellphoneRegex.test(cellphone);
        },

        // reCAPTCHA methods
        loadRecaptchaScript() {
            const script = document.createElement('script');
            script.src = 'https://www.google.com/recaptcha/api.js?render=6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; // Replace with your actual sitekey
            script.async = true;
            script.defer = true;
            script.onload = this.renderRecaptcha;
            document.head.appendChild(script);
        },

        renderRecaptcha() {
            grecaptcha.ready(() => {
                grecaptcha.render(this.$refs.recaptchaContainer, {
                    sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // Replace with your actual sitekey
                    callback: this.onRecaptchaVerified
                });
            });
        },

        onRecaptchaVerified(response) {
            console.log('reCAPTCHA verified:', response);
            this.recaptchaToken = response;
        },

        executeRecaptcha() {
            grecaptcha.execute('6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', { action: 'submit' }).then(token => { // Replace with your actual sitekey
                console.log('reCAPTCHA Token:', token);
                this.submitForm();
            });
        },

        submitForm() {
            // Perform form validation and submission logic

            if (!this.honeyPot.firstname && !this.honeyPot.lastname && this.validateForm()) {
                // Form is valid, perform the desired action
                if (this.recaptchaToken !== '') {
                    // reCAPTCHA is verified, perform the desired action
                    console.log('Form submitted successfully');
                    this.$router.push('/webinar');
                } else {
                    this.recaptchaError = 'Please confirm the captcha';
                }
            } else {
                this.recaptchaError = 'Please confirm the captcha';
            }
        },
    },
};
</script>